import { PurchaseFlowProduct, PurchaseFlowProductOption } from 'components/pages/PurchaseFlow/_main/contexts/PurchaseFlowProducts.context'

import { ProductKind } from 'constants/product'
import { ProductType } from 'constants/product'

export interface AggregatedOptionEntry {
  option: PurchaseFlowProductOption
  count: number
  parentType: ProductType
  parentKind: ProductKind
}

/**
 * Sum quantities of same-id option products across multiple parents.
 * The order payload is a flat list, so duplicate ids would be deduped by the BE.
 */
export function aggregateOptionsAcrossParents(
  parents: PurchaseFlowProduct[],
  selectedProductOptions: Record<number, Record<number, PurchaseFlowProductOption>>
): AggregatedOptionEntry[] {
  const aggregated = new Map<number, AggregatedOptionEntry>()

  for (const parent of parents) {
    const productOptions = selectedProductOptions[parent.id]
    if (!productOptions) continue

    for (const optionKey in productOptions) {
      const option = productOptions[optionKey]
      const existing = aggregated.get(option.id)

      if (existing) {
        existing.count += option.quantity
      } else {
        aggregated.set(option.id, {
          option,
          count: option.quantity,
          parentType: parent.type,
          parentKind: parent.kind,
        })
      }
    }
  }

  return Array.from(aggregated.values())
}
